<template>

  <div class="dialog" v-if="dialogOpen">
    <span class="close" @click="openDialog(false)"></span>
    <div class="paper">
      <div class="header"> <h1>보장 분석 수정</h1> <span @click="openDialog(false)">X</span> </div>
      
      <form>
        <div class="item">
          <label>게시판 이름</label>
          <input type="text" v-model="editingBoard.name" placeholder="게시판 이름" />
        </div>
        <div class="item">
          <label>설명</label>
          <textarea v-model="editingBoard.description" placeholder="게시판 설명"></textarea>
        </div>
        <div class="item">
          <label>정렬 순서</label>
          <input type="text" v-model="editingBoard.sort_order" placeholder="정렬 순서" />
        </div>
        <div class="btns">
          <button type="button" >취소</button>
          <button type="button" @click="saveBoard" class="confirm">확인</button>
        </div>
      </form>
      
    </div>
  </div>

  <div class="admin-main">
    
    <div class="header">
      <h2>게시판 관리</h2>
    </div>

    <div class="content">
      
      <div class="boards">
        <div class="chapter">
          <button :class="{ active: viewingTab === 'board' }" @click="viewingTab = 'board'">게시판 관리</button>
          <button :class="{ active: viewingTab === 'post' }" @click="viewingTab = 'post'">글 관리</button>
        </div>

        <ul class="grid" v-if="viewingTab == 'board'">
          <li class="add" @click="editBoard(null)"> <i class="ph ph-plus"></i> <span>새 게시판</span> </li>
          <li v-for="board in board_list" :key="board.id" @click="editBoard(board)">
            <span>{{ board.name }} ({{ board.sort_order }})</span>
            <div class="btns">
              <button @click.stop="deleteBoard(board.idx, $event)">삭제</button>
            </div>
          </li>
        </ul>

        <ul class="list" v-if="viewingTab == 'post'">
          <li v-for="post in post_list" :key="post.id">
            <img :src="post.thumb && post.thumb.trim() !== '' ? post.thumb : '/imgs/empty_image.png'" alt="Thumbnail" class="thumb" />
            <span>{{ post.title }}<br>({{ getBoardNameById(post.category_id) }})</span>
            <div class="btns">
              <button @click.stop="deletePost(post.idx)">삭제</button>
            </div>
          </li>
        </ul>
      </div>

    </div>

  </div>
</template>


<script>
import { inject, ref } from "vue";

export default {
  name: "boardAdmin",
  setup() {
    const sql_query = inject("sql_query");
    const member_info = inject("member_info");
    const dialogOpen = ref(false);
    const editingBoard = ref(null);
    const viewingTab = ref("board");

    const board_list = ref([]);
    const post_list = ref([]);

    async function fetchBoards() {
      const result = await sql_query(" select * from board_category order by sort_order asc ");
      if (result && result.length > 0) {
        board_list.value = result;
      }
    }
    fetchBoards();

    async function fetchPosts() {
      const result = await sql_query(" select * from board_reference order by created_at desc ");
      if (result && result.length > 0) {
        post_list.value = result;
      }
    }
    fetchPosts();

    async function saveBoard() {
      if (!editingBoard.value || !editingBoard.value.name) {
        alert("게시판 이름을 입력해주세요.");
        return;
      }
      const board = editingBoard.value;

      if (board.idx) {
        // update
        await sql_query(`UPDATE board_category SET name='${board.name}', description='${board.description}', sort_order=${board.sort_order} WHERE idx=${board.idx}`);
      } else {
        // insert
        await sql_query(`INSERT INTO board_category (name, description, sort_order) VALUES ('${board.name}', '${board.description}', ${board.sort_order})`);
      }

      fetchBoards();
      openDialog(false);
    }

    async function deleteBoard(boardId, event) {
      if (confirm("정말로 이 게시판을 삭제하시겠습니까?")) {
        console.log(event.target);
        event.target.closest('.board-item').classList.add('fade-out');
        await sql_query(`DELETE FROM board_category WHERE idx=${boardId}`);
        fetchBoards();
      }
    }

    async function deletePost(postId) {
      if (confirm("정말로 이 글을 삭제하시겠습니까?")) {
        await sql_query(`DELETE FROM board_reference WHERE idx=${postId}`);
        fetchPosts();
      }
    }

    function openDialog(b) {
      dialogOpen.value = b;
      // input 비우기
    }

    function editBoard(board) {
      if (board === null) {
        editingBoard.value = { name: "", description: "", sort_order: 0 };
      } else {
        editingBoard.value = { ...board };
      }
      openDialog(true);
    }

    function getBoardNameById(boardId) {
      const board = board_list.value.find(b => b.idx === boardId);
      return board ? board.name : "";
    }

    return {
      member_info,
      sql_query,
      board_list,
      dialogOpen,
      openDialog,
      editBoard,
      editingBoard,
      saveBoard,
      deleteBoard,
      viewingTab,
      post_list,
      deletePost,
      getBoardNameById
    };
  }
};

</script>


<style scoped>

@keyframes fadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

.fade-out {
  animation: fadeOut 0.5s ease-out forwards;
}

#circleContainer {
  width:100%;
  height:100%;
  margin:0 auto;
}

.dialog {
  width:100%;
  height:100%;
  position: absolute;
  left:0;
  top:0;
  background-color: rgba(0,0,0,0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9;
}

.dialog > .close {
  position: absolute;
  z-index: -1;
  right: 0;
  top: 0;
  width:100%;
  height:100%;
}

.dialog > .paper {
  position: relative;
  width: 100%;
  max-width:600px;
  height: 80%;
  background-color: var(--color-background);
  border:1px solid var(--color-text-primary);
  border-radius: 16px;
  padding: 16px;
  box-sizing: border-box;
  overflow:scroll;
}

.dialog > .paper::-webkit-scrollbar {
  display: none;
}

.dialog > .paper > .header {
  width:100%;
  height:48px;
  display:flex;
  justify-content: space-between;
  align-items: center;
  font-size: var(--font-size-lg);
}

.dialog > .paper > .header > h1 {
  font-size:20px;
}

.dialog > .paper > .header > span {
  width:48px;
  height:48px;
  display:flex;
  justify-content: center;
  align-items: center;
  cursor:pointer;
}

.dialog > .paper > form {
  width:100%;
  height:fit-content;
  display:flex;
  flex-direction: column;
  gap:12px;
}

.dialog > .paper > form > .item {
  width:100%;
  height:fit-content;
  display:flex;
  flex-direction: column;
  gap:6px;
}

.dialog > .paper > form > .item > label {
  font-size:16px;
  color: var(--color-text-primary);
}

.dialog > .paper > form > .item > input,
.dialog > .paper > form > .item > textarea {
  width:100%;
  height:40px;
  border:1px solid var(--color-text-secondary);
  border-radius:8px;
  padding:8px;
  box-sizing: border-box;
  font-size:16px;
  color: var(--color-text-primary);
}

.dialog > .paper > form > .item > textarea  {
  height:80px;
}

.dialog > .paper > form > .btns {
  position: absolute;
  bottom:16px;
  left:16px;
  width:95%;
  height:fit-content;
  display:flex;
  flex-direction: row;
  justify-content: end;
  align-items: center;
  gap:12px;
}

.dialog > .paper > form > .btns > button {
  width:100%;
  height:40px;
  flex:1;
  background-color: var(--color-background-light);
  color: var(--color-text-primary);
  border:none;
  border-radius:8px;
  cursor:pointer;
  font-size:16px;
  font-weight: 700;
}

.dialog > .paper > form > .btns > button.confirm {
  background-color: var(--color-brand);
  color: var(--color-text-black);
}

.admin-main {
  width:100%;
  height: 100%;
  display:flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
  background-color: var(--color-background);
}

.admin-main > .header { 
  width: 100%;
  height: 60px;
  display: flex;
  justify-content: start;
  align-items: center;
  color: var(--color-text-primary);
  border-bottom: 1px solid var(--color-surface-reverse);
  padding:16px;
  box-sizing: border-box;
}

.content {
  width:100%;
  height:90%;
  flex:1;
  padding:16px;
  box-sizing: border-box;
  display:flex;
  flex-direction: column;
  justify-content: start;
  align-items: start;
  gap:16px;
}

.admin-main .header {
  width:100%;
  display:flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;
}

.admin-main .header > h2 {
  font-size: 24px;
  color: var(--color-text-primary);
  display:flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;
  padding:0;
  margin:0;
  gap:12px;
}

.admin-main .header > h2 > b {
  font-size:36px;
}

.boards {
  width:100%;
  height:100%;
  display:flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
  gap:16px;
  background: var(--color-background-light);
  border-radius: 12px;
  padding: 16px;;
  box-sizing: border-box;
  overflow-y:scroll;
}

.boards > .chapter {
  width:100%;
  height:48px;
  display:flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;
  gap:12px;
}

.boards > .chapter > button {
  flex: 1;
  height:100%;
  background:none;
  border:none;
  cursor:pointer;
  font-size:var(--font-size-lg);
  border-bottom: 1px solid var(--color-text-secondary);
}

.boards > .chapter > button.active {
  border-bottom: 1px solid var(--color-text-primary);
}

.boards > h2 {
  width:100%;
  height: fit-content;
  font-size: 20px;
  color: var(--color-text-primary);
  padding:16px;
  box-sizing: border-box;
  text-align: center;
  display:flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;
  padding: 0;
  margin: 0;
}

.boards > ul.grid {
  width:100%;
  height: fit-content;
  list-style: none;
  padding: 0;
  margin: 0;
  display:grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap:12px;
}

.boards > ul.grid > li {
  position: relative;
  width: 100%;
  aspect-ratio: 1/1;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 24px;
  cursor: pointer;
  color: var(--color-text-primary);
  background: var(--color-surface-reverse);
  border-radius: 12px;
  flex-direction: column;
  gap:12px;
  overflow: hidden;
}

.boards > ul.grid > li > .btns {
  position: absolute;
  bottom:0;
  left:0;
  width:100%;
  height:36px;
  display:flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background: var(--color-surface-reverse);
}

.boards > ul.grid > li > .btns > button {
  width: 100%;
  height: 100%;
  background: var(--color-background);
  color: var(--color-text-primary);
  border:none;
  border-radius:0;
  cursor:pointer;
  font-size:16px;
  font-weight: 600;
}

.boards > ul.grid > li.add {
  background: transparent;
  color: var(--color-text-primary);
  border: 2px dashed var(--color-brand);
}

.boards > ul.list {
  width:100%;
  height: fit-content;
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap:12px;
}

.boards > ul.list > li {
  width:100%;
  height:90px;
  background:var(--color-surface-reverse);
  border-radius: 12px;
  display:flex;
  align-items: center;
  gap:16px;
  overflow:hidden;
}

.boards > ul.list > li > img {
  height:90px;
  width:auto;
  aspect-ratio: 16/9;
  object-fit: cover;
  border-radius: 12px;
}

.boards > ul.list > li > span {
  width:100%;
  height:100%;
  flex:1;
  display:flex;
  justify-content: start;
  align-items: center;
}

.boards > ul.list > li > .btns {
  width:60px;
  height:100%;
  box-sizing: border-box;
  background:var(--color-surface-deep);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.boards > ul.list > li > .btns > button {
  width: 100%;
  height: 100%;
  background: var(--color-background);
  color: var(--color-text-primary);
  border: none;
  border-radius: 0;
  cursor: pointer;
  font-size: 16px;
  font-weight: 600;
}

</style>